import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../hospital.css';
import '../../assets/css/mainstyle.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './locationlist.css'
import {
    CContainer,
    CButton,
    CRow,
    CCol,
    CCard,
    CCardBody,
    CTable,
    CTableBody,
    CTableDataCell,
    CTableHead,
    CTableHeaderCell,
    CTableRow
} from '@coreui/react'
import { FaTrash, FaFolderOpen, FaEllipsisV, FaEdit } from "react-icons/fa";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // N'oublie pas d'importer les styles de toast
import api from '../../service/caller';
import Adminprofil from '../../assets/images/adminprofil.png';
import AddLocation from './addlocation';
import { format } from 'date-fns';

const Genaralconfig = () => {
    const [UserData, setUserData] = useState([]);
    const [hospitals, setHospitals] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showaddLocationModal, setShowaddLocationModal] = useState(false);
    const navigate = useNavigate();


    const handleAddLocation = () => {
        setShowaddLocationModal(true);
    };

    useEffect(() => {
        const fetchLoggedUserData = async () => {
            try {
                const response = await api.get('api/usersprofile');

                setUserData(response.data);
            } catch (error) {
                toast.error("Failed to fetch data");
            }
        };
        fetchLoggedUserData();
    }, []);

    useEffect(() => {
        const fetchHospitals = async () => {
            if (!UserData || !UserData._id) return;

            try {
                setLoading(true);

                const userId = UserData._id;

                const response = await api.post('/api/user-hospitals', { userId });
                setHospitals(response.data.hospitals);
                setError(null);
            } catch (err) {
                setError(err.response?.data?.message || 'Une erreur est survenue');
                console.error('Erreur:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchHospitals();
    }, [UserData]);


    const handleEditClick = (hospitalId) => {
        navigate(`/hospitaladmin/editLocation/${hospitalId}`, {
            state: { hospitalId },
        });
    };



    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    const handleDelete = async (id) => {
        const confirmDelete = window.confirm("Êtes-vous sûr de vouloir supprimer cet hôpital ?");
        if (!confirmDelete) return;

        try {
            const response = await api.delete(`/api/deletehospital/${id}`);
            toast.success(response.data.message);
            // rafraîchir la liste ou rediriger
        } catch (error) {
            if (error.response && error.response.data.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Erreur lors de la suppression.");
            }
        }
    };


    return (

        <div className="locationlist-dashboard-header">
            <ToastContainer />
            <div className="hosp-profile-header" style={{ backgroundColor: 'var(--hosp-background-color)', border: "none" }}>
                <div className="hosp-header__content">
                    {/* Titre à gauche */}
                    <div className="hosp-header__title">
                        <h4 className="hosp-page__title"><b>Location Settings</b></h4>
                    </div>

                    {/* Profil utilisateur à droite */}
                    <div className="hosp-user__profile">
                        {/* Indicateur de statut en ligne (optionnel) */}
                        <div className="hosp-status__indicator"></div>

                        <img
                            src={UserData?.picture || Adminprofil}
                            className='hosp-profile__image'
                            alt="Profile Icon"
                        />

                        <div className="hosp-user__details">
                            <span className="hosp-user__name">{UserData.firstname} {UserData.lastname}</span>
                            <p className="hosp-user__role">
                                {UserData.role?.name}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <section className="locationlist-section">
                <CRow>
                    <CCol xs={12}>
                        <CCard className="locationlist-card mb-4 p-4">
                            <CCardBody>
                                <div>
                                    <button onClick={handleAddLocation} className="btn btn-primary mt-2">Add Location</button>

                                    {showaddLocationModal && <AddLocation closeModal={() => setShowaddLocationModal(false)} />}
                                </div>
                                <div>
                                    <div className="locationlist-hospitalListTable mt-5">
                                        <h4>Hospitals</h4>
                                        <CTable className="mt-2 locationlist-table" align="middle" responsive>
                                            <CTableHead>
                                                <CTableRow className="locationlist-tablehead">
                                                    <CTableHeaderCell scope="col">ID</CTableHeaderCell>
                                                    <CTableHeaderCell scope="col">NAME</CTableHeaderCell>
                                                    <CTableHeaderCell scope="col">ADDRESS</CTableHeaderCell>
                                                    <CTableHeaderCell scope="col">PHONE</CTableHeaderCell>
                                                    <CTableHeaderCell scope="col">Currency</CTableHeaderCell>
                                                    <CTableHeaderCell scope="col">Created AT</CTableHeaderCell>
                                                    <CTableHeaderCell scope="col">ACTION</CTableHeaderCell>
                                                </CTableRow>
                                            </CTableHead>
                                            <CTableBody>
                                                {hospitals.map((hospital) => (
                                                    <CTableRow className="locationlist-table-row" key={hospital._id}>
                                                        <CTableDataCell align="middle">{hospital.hospital_spec_id}</CTableDataCell>
                                                        <CTableDataCell>{hospital.hospital_name}</CTableDataCell>
                                                        <CTableDataCell>{hospital.hospital_country}, {hospital.hospital_state_province}, {hospital.hospital_city}</CTableDataCell>
                                                        <CTableDataCell>{hospital.hospital_phone}</CTableDataCell>
                                                        <CTableDataCell>{hospital.hospital_currency}</CTableDataCell>
                                                        <CTableDataCell>{format(new Date(hospital.createdAt), "yyyy-MM-dd HH:mm")}</CTableDataCell>
                                                        <CTableDataCell>
                                                            <div className="locationlist-actions">
                                                                <div className="locationlist-dropdown">
                                                                    <FaEllipsisV
                                                                        className="locationlist-dropdown-icon"
                                                                        data-coreui-toggle="dropdown"
                                                                        aria-expanded="true"
                                                                        style={{ color: 'Green' }}
                                                                    />
                                                                    <ul className="dropdown-menu">
                                                                        <li>
                                                                            {/* Action "Voir les détails" */}
                                                                            <a className="dropdown-item" href={`/hospitaladmin/hospitalDetails/${hospital._id}`}>
                                                                                <FaFolderOpen className="locationlist-icon" />
                                                                                View Details
                                                                            </a>
                                                                        </li>
                                                                        <li>
                                                                            {/* Action "Éditer" */}
                                                                            <CButton
                                                                                onClick={() => handleEditClick(hospital._id)}
                                                                                className="dropdown-item locationlist-button"
                                                                                tabIndex={-1}
                                                                            >
                                                                                <FaEdit className="locationlist-icon" />
                                                                                Edit {hospital.hospital_name}
                                                                            </CButton>
                                                                        </li>
                                                                        <li>
                                                                            <CButton
                                                                                className="dropdown-item locationlist-button"
                                                                                onClick={() => handleDelete(hospital._id)}
                                                                            >
                                                                                <FaTrash className="locationlist-icon" />
                                                                                Delete
                                                                            </CButton>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </CTableDataCell>
                                                    </CTableRow>
                                                ))}
                                            </CTableBody>
                                        </CTable>
                                    </div>
                                </div>
                            </CCardBody>
                        </CCard>
                    </CCol>
                </CRow>
            </section>
        </div>
    );
};

export default Genaralconfig;
